import React from "react";
import { useQuery } from "react-query";
import { getBusinessMenu } from "./gateway";
import { AxiosResponse } from "axios";

type TCompanyStatus = {
  approvedCompanyByLegalTypes: boolean;
  isListedCompany: boolean;
  companySuspension: boolean;
};

export default function useGetBusinessMenu({ enabled }: { enabled: Boolean }) {
  return useQuery<AxiosResponse<TCompanyStatus>>({
    queryFn: getBusinessMenu,
    enabled: !!enabled,
  });
}
